<ng-template #itemTemplate let-item let-context="context">
	@if (item.hasCheckbox) {
		<i class="ico" [ngClass]="{ 'ico-check': item.value || (item.getValue && item.getValue()) }"></i>
	}
	@if (!item.hasCheckbox && !!item.iconClass) {
		<i class="ico" [ngClass]="item.iconClass"></i>
	}

	@if (item.name) {
		<p
			[translate]="isFunction(item.name) ? item.name(context) : item.name"
			[translateParams]="{ ARG0: item.nameParamValue ? item.nameParamValue : (item.nameParam | translate) }"
		></p>
	}
	@if (item.translated && isFunction(item.translated)) {
		<p>{{ item.translated(context) }}</p>
	}
	@if (item.translated && !isFunction(item.translated)) {
		<p>{{ item.translated }}</p>
	}
	@if (!!item.secondaryIconClass) {
		<i [ngClass]="item.secondaryIconClass"></i>
	}

	@if (item.expandable) {
		<stages-button-expand-collapse [isCollapsed]="!item.isExpanded" />
	}
</ng-template>

<ng-template #clickTypeTemplate let-node>
	@if (node.on) {
		<a (click)="node.on(context())">
			<ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: node, context: context() }"></ng-container>
		</a>
	}

	@if (node.routerLink) {
		<a [routerLink]="node.routerLink(context())">
			<ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: node, context: context() }"></ng-container>
		</a>
	}

	@if (node.href) {
		<a [href]="node.href(context())">
			<ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: node, context: context() }"></ng-container>
		</a>
	}
</ng-template>

<ng-template #pinTemplate let-node>
	<div class="item-container-pinned">
		@if (!node.isSwitch && node.on) {
			<a (click)="node.on(context())">
				<ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: node, context: context() }"></ng-container>
			</a>
		}
		<div class="pin" [ngClass]="{ pinned: node.isPinSet(node.id) }" (click)="node.setPinnedItem(node.id)">
			<i class="ico ico-pin"></i>
		</div>
	</div>
</ng-template>

<ng-template #switchTemplate let-node>
	@if (node.nameParamValue) {
		<span class="h6" [translate]="node.name" [translateParams]="{ ARG0: node.nameParamValue }"></span>
	}
	@if (!node.nameParamValue) {
		<span class="h6" [translate]="node.name" [translateParams]="{ ARG0: (node.nameParam | translate) }"></span>
	}
	<div class="switch-container">
		<stages-switch
			id="mi_child_{{ menuId() }}_{{ node.id ? node.id : node.name }}"
			[value]="node.getValue(context())"
			(valueChange)="node.onValueChange($event, context())"
		></stages-switch>
	</div>
</ng-template>

<ng-template #baseTemplate let-node let-isGroupHeader="isGroupHeader">
	@if (!node.isSeparator) {
		<li class="mi full-length" [ngClass]="{ 'switch-item': node.isSwitch, 'pin-item': node.hasPin }">
			@if (isGroupHeader) {
				<a stagesClickStopPropagation (click)="node.isExpanded ? (node.isExpanded = false) : (node.isExpanded = true)">
					<ng-container
						*ngTemplateOutlet="itemTemplate; context: { $implicit: node, context: context() }"
					></ng-container>
				</a>
			}
			@if (!isGroupHeader) {
				@if (!node.isSwitch) {
					<ng-container
						*ngTemplateOutlet="
							node.hasPin ? pinTemplate : clickTypeTemplate;
							context: { $implicit: node, context: context() }
						"
					></ng-container>
				}
				@if (node.isSwitch) {
					<div stagesClickStopPropagation>
						<ng-container
							*ngTemplateOutlet="switchTemplate; context: { $implicit: node, context: context() }"
						></ng-container>
					</div>
				}
			}
		</li>
	}
	@if (node.isSeparator) {
		<li class="mi full-length divider"></li>
	}
</ng-template>

@if (finishedLoading && filteredItems.length > 0) {
	<div class="menu-wrapper" [ngClass]="classes()!">
		@if (collapseMenu(filteredItems)) {
			<div class="menu-container">
				<!-- title="{{ ::items[0].name | translate: '{ARG0: (items[0].nameParam | translate)}' }}" -->
				<ng-container *ngTemplateOutlet="collapsedMenuButton; context: { $implicit: filteredItems[0] }"></ng-container>
			</div>
		}
		@if (!collapseMenu(filteredItems)) {
			<div class="menu-container" [ngClass]="{ 'toolbar-dropdown-container': isToolbarDropdown() }">
				<button
					[attr.title]="buttonNameKey() | translate"
					[attr.aria-label]="buttonNameKey() | translate"
					class="menu-button"
					[ngClass]="{ 'button sm add toolbar-dropdown': isToolbarDropdown() }"
					(click)="toggle($event)"
				>
					@if (iconClasses) {
						<i class="ico" [ngClass]="iconClasses"></i>
					}
					<ng-content></ng-content>
				</button>
				@if (open) {
					<ul class="menu fade open-{{ openTo() }}" [id]="menuId()" [ngClass]="{ title: hasTitle, slim: slim() }">
						@if (hasTitle) {
							<li class="mi title-container">
								<div class="title-content">
									<i class="ico" [ngClass]="titleIconClass()!"></i>
									<div class="label">
										<div class="text">
											@if (menuTitle && titleParams()) {
												<p [translate]="menuTitle" [translateParams]="{ ARG0: titleParams()![0] }"></p>
											}
											@if (subtitle && titleParams()) {
												<span class="h6" [translate]="subtitle" [translateParams]="{ ARG0: titleParams()![0] }"></span>
											}
										</div>
									</div>
								</div>
							</li>
						}
						<cdk-tree [dataSource]="dataSource" [treeControl]="treeControl" [trackBy]="trackByIndex">
							<cdk-tree-node *cdkTreeNodeDef="let node" [style.display]="shouldRender(node) ? 'flex' : 'none'">
								<ng-container
									*ngTemplateOutlet="baseTemplate; context: { $implicit: node, context: context() }"
								></ng-container>
							</cdk-tree-node>
							<cdk-tree-node
								*cdkTreeNodeDef="let node; when: hasChild"
								[style.display]="shouldRender(node) ? 'flex' : 'none'"
							>
								<ng-container
									*ngTemplateOutlet="
										baseTemplate;
										context: { $implicit: node, context: context(), isGroupHeader: true }
									"
								></ng-container>
							</cdk-tree-node>
						</cdk-tree>
					</ul>
				}
			</div>
		}
	</div>
}

<ng-template #collapsedMenuButton let-item>
	@if (item.routerLink) {
		<a [routerLink]="item.routerLink(context())">
			<button [attr.aria-label]="item.name | translate" [attr.title]="item.name | translate" class="menu-button">
				<i [ngClass]="item.iconClass"></i>
			</button>
		</a>
	}
	@if (!item.routerLink) {
		<button
			[attr.aria-label]="item.name | translate"
			[attr.title]="item.name | translate"
			class="menu-button"
			(click)="item.on(context())"
		>
			<i [ngClass]="item.iconClass"></i>
		</button>
	}
</ng-template>
